export const LOCAL_STORAGE_KEY = {
  TOKEN: "token"
};
